import * as React from "react";
import * as ReactDOM from "react-dom";


interface IProperties
{
    children?: any;
    style?: any;
}

export class InputHint extends React.Component<IProperties>
{
    render()
    {
        return (
            <div
                className="input-hint"
                style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}